import { Injectable } from '@angular/core';
import { Router, UrlTree } from '@angular/router';

import { combineLatest, Observable } from 'rxjs';
import { filter, map } from 'rxjs/operators';

import { SAJ_ROUTES } from '@libs/types/navigation';

import {
  AuthenticationService,
  IAccount,
  LocationManagerExperienceConfig,
  LocationManagerExperienceService,
} from '../services';

@Injectable()
export class DefaultPageGuard {
  constructor(
    private lmExperienceService: LocationManagerExperienceService,
    private auth: AuthenticationService,
    private router: Router,
  ) {}

  canActivateChild(): Observable<boolean | UrlTree> {
    return combineLatest([
      this.lmExperienceService.getExperience(),
      this.auth.account$.pipe(filter((account: IAccount) => !!account.id)),
    ]).pipe(
      map(([config, account]: [LocationManagerExperienceConfig, IAccount]) => {
        if (config.isLocationManager) {
          return this.router.parseUrl(SAJ_ROUTES.Candidates);
        }
        if (account.accountTier === 'LegacyEComm') {
          return this.router.parseUrl(SAJ_ROUTES.PostingList);
        }
        return true;
      }),
    );
  }
}
